import * as L from "lucide-react";
import { api } from "@/api";

const NAMES = ["Utensils", "ShoppingBag", "Hotel", "FerrisWheel", "Tent", "Music", "Laugh", "Ticket", "Truck", "Wheat", "SprayCan", "Wrench", "HardHat", "Car", "Scissors", "Flower2",
  "Dumbbell", "Camera", "Laptop", "Briefcase", "Building", "Warehouse", "ShieldCheck", "GraduationCap", "CarFront", "PawPrint", "TreePine", "HeartHandshake", "Users", "Network", "Store", "Puzzle"];
export const METIER_ICONS = Object.fromEntries(NAMES.map((n) => [n, L[n] || L.Briefcase]));
export const metierIcon = (name) => METIER_ICONS[name] || L.Briefcase;

let cache = null;
/** Référentiel public des modules métier (mis en cache pour la session). */
export async function loadMetiers() {
  if (cache) return cache;
  const { data } = await api.get("/public/metiers");
  cache = data.metiers || [];
  return cache;
}
export const resetMetiersCache = () => { cache = null; };

export const norm = (s) => (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
export const matchMetier = (m, q) => !q || [m.label, m.audience, m.code, m.description].some((v) => norm(v).includes(norm(q)));
